// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1f960028","698":"2dfd6df4"}[chunkId] + ".chunk.js";
};